import { money } from "../utils/formatters";

/**
 * Componente que muestra la lista de clientes con sus troncales
 */
export default function ClientesList({ clientes = [], troncales = {}, clientesOpen = {}, onToggleCliente }) {
    if (!clientes.length) {
        return (
            <div className="p-3 text-xs text-slate-500 bg-slate-50 flex items-center gap-3">
                <span className="text-lg">👥</span>
                <span>Esta empresa aún no tiene clientes.</span>
            </div>
        );
    }

    return (
        <div className="border-t border-slate-100">
            {clientes.map((c) => {
                const isOpen = !!clientesOpen[c.id];
                const clienteTroncales = troncales[c.id] || [];

                return (
                    <div key={c.id} className="border-b border-slate-100 last:border-b-0">
                        {/* Header del cliente */}
                        <button
                            onClick={() => onToggleCliente(c.id)}
                            className="w-full p-2 flex items-center justify-between hover:bg-slate-50 transition-all group"
                            type="button"
                        >
                            <div className="flex items-center gap-2">
                                <span className="text-base">👥</span>
                                <div className="text-left">
                                    <div className="font-medium text-slate-800 text-sm group-hover:text-indigo-700">
                                        {c.nombre}
                                    </div>
                                    <div className="text-[11px] text-slate-500 mt-0.5 flex items-center gap-2">
                                        <span>Depósito:</span>
                                        <span className="bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full text-[11px] font-medium">
                                            {money(c.deposito_asignado)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`text-slate-400 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                                    }`}
                            >
                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path
                                        fillRule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div>
                        </button>

                        {/* Lista de troncales (expandible) */}
                        <div
                            className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
                                }`}
                        >
                            <div className="bg-gradient-to-r from-slate-50 to-indigo-50 p-2">
                                {clienteTroncales.length ? (
                                    <div className="space-y-2">
                                        {clienteTroncales.map((t, index) => (
                                            <div
                                                key={t.id}
                                                className="flex items-center justify-between rounded-md border border-slate-200 bg-white/80 p-2 hover:shadow-sm hover:border-indigo-200 transition-all"
                                                style={{ animationDelay: `${index * 50}ms` }}
                                            >
                                                <div className="flex items-center gap-2">
                                                    <span className="text-base">📞</span>
                                                    <div className="font-medium text-slate-700 text-sm">
                                                        {t.nombre}
                                                    </div>
                                                </div>
                                                <div className="bg-indigo-100 text-indigo-700 px-2 py-1 rounded-full text-[11px] font-medium">
                                                    #{t.id}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-xs text-slate-500 bg-white/60 p-2 rounded-lg flex items-center gap-2">
                                        <span className="text-base">📞</span>
                                        <span>No hay troncales registradas.</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}